import React from 'react';
import { DatasetTable } from '@/features/datasets';

export const IMPROVE_MODAL_TABLE_PAGE_SIZE = 15;

const IMPROVEMENT_MODE_PROPS = {
    showProTip: false,
    enableTour: false,
};

export default function ImproveFlowHumanStep({
    usecase,
    dataset,
    metadata,
    availableExtraParamsKeys,
    crossReferenceFields,
    isLoading,
    handleTableChange,
    setIsInDB,
    currentFilters,
    activeSorter,
    setCurrentFilters,
    setActiveSorter,
    allLabelOptions,
    refreshCategories,
    updateRecord,
    onNestedOverlayChange,
    showTourOnOpen = false,
    onTourClose,
    onValidationProgressChange,
    onTablePopoverChange,
    focusIncompleteToken = 0,
}) {
    return (
        <DatasetTable
            title={null}
            dataset={dataset}
            metadata={metadata}
            availableExtraParamsKeys={availableExtraParamsKeys}
            crossReferenceFields={crossReferenceFields}
            isLoading={isLoading}
            currentUsecase={usecase}
            isBenchmark={false}
            handleTableChange={handleTableChange}
            setIsInDB={setIsInDB}
            pageSize={IMPROVE_MODAL_TABLE_PAGE_SIZE}
            currentFilters={currentFilters}
            activeSorter={activeSorter}
            setCurrentFilters={setCurrentFilters}
            setActiveSorter={setActiveSorter}
            datasetName={usecase?.datasets?.[0]}
            allLabelOptions={allLabelOptions}
            refreshCategories={refreshCategories}
            updateRecord={updateRecord}
            isArchived={false}
            columnPreset="improve-modal"
            improvementModeProps={{
                ...IMPROVEMENT_MODE_PROPS,
                showTourOnOpen,
                onTourClose,
                focusIncompleteToken,
            }}
            onNestedOverlayChange={onNestedOverlayChange}
            onValidationProgressChange={onValidationProgressChange}
            onTablePopoverChange={onTablePopoverChange}
        />
    );
}
